import { schema } from 'normalizr';

export const toxProfileItemSchema = new schema.Entity('toxProfileItem', {}, { idAttribute: 'ToxProfileItemId' });
export const toxProfileItemListSchema = [toxProfileItemSchema];
